import { render, staticRenderFns } from "./AddVenue.vue?vue&type=template&id=2ecd9662&scoped=true"
import script from "./AddVenue.vue?vue&type=script&lang=js"
export * from "./AddVenue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../Vue/course_selecttion_v3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecd9662",
  null
  
)

export default component.exports